import './nav.css'
import {AiOutlineHome} from 'react-icons/ai'
import {BiBook, BiUserCircle} from 'react-icons/bi'
import {MdWork} from 'react-icons/md'
import {useState} from 'react'

const Nav = () => {
  const [activeNav, setActiveNav] = useState('#')
  return (
    <nav>
      <a href="#" onClick={() => setActiveNav('#')}  className={activeNav === '#' ? 'active' : ''}><AiOutlineHome /><span>Home</span></a>
      <a href="#about" onClick={() => setActiveNav('#about')} className={activeNav === '#about' ? 'active' : ''}>
        <BiUserCircle />
        <span>About</span>
      </a>
      <a href="#experience" onClick={() => setActiveNav('#experience')} className={activeNav === '#experience' ? 'active' : ''}>
        <MdWork />
        <span>News</span>
      </a>
      <a href="#publication" onClick={() => setActiveNav('#publication')} className={activeNav === '#publication' ? 'active' : ''}>
        <BiBook />
        <span>Publications</span>
      </a>
    </nav>
  )
}

export default Nav
